import { SxProps, Theme } from '@mui/material';
import { darken } from '@mui/material/styles';

const ICON_BUTTON_HOVER_DARKEN = 0.05;

export const searchBarIconButtonSx: SxProps<Theme> = (theme) => ({
  p: 0,
  color: theme.palette.text.secondary,
  '&:hover': {
    backgroundColor: darken(theme.palette.action.selected, ICON_BUTTON_HOVER_DARKEN),
  },
});
